import { Product, DefaultProduct } from 'src/app/models/product.model';
import { reducedPrice } from 'src/app/utils/animation.utils';

export enum OrderStatus {
  CREATED = 1,
  SHIPPED = 2
}

export interface OrderProduct {
  quantity: number;

  product: Product;
}

export const DefaultOrderProduct: OrderProduct = {
  quantity: 1,
  product: DefaultProduct
}

export interface Order {
  id: number;
  order_date: Date;
  status: OrderStatus;
  products: Array<OrderProduct>;
}

export const DefaultOrder: Order = {
  id: 2883928,
  order_date: new Date(),
  status: OrderStatus.CREATED,
  products: [DefaultOrderProduct, DefaultOrderProduct, DefaultOrderProduct, DefaultOrderProduct, DefaultOrderProduct, DefaultOrderProduct, DefaultOrderProduct]
}

export function totalPrice(order: Order) {
  let sum = 0;
  for (const order_product of order.products) {
    sum += order_product.quantity * reducedPrice(order_product.product)
  }
  return sum;
}

export function ordersProductsToString(order: Order) {
  let str = '';
  let i = 0;
  for (const order_product of order.products) {
    if (i != 0) {
      str += ', ';
    }
    str += order_product.quantity + ' ' + order_product.product.name;
    i++;
  }
  return str;
}

export function orderStatusToString(orderStatus: OrderStatus) {
  let str = ''
  if (orderStatus == OrderStatus.CREATED)
    str = 'CREATED';
  else if (orderStatus == OrderStatus.SHIPPED)
    str = 'SHIPPED';
  return str;
}
